import moment from "moment";
import i18nLocale from "@/helpers/locale";
import tranfResData from "@/utils/tranfResData";
import { positiveNumValidator, percentageValidator } from "@/utils/formFieldValidator";
import { adminTypeList } from "@/utils/common";

export const deviceList = [
  {
    label: i18nLocale("global.POS"),
    value: "POS",
  },
  {
    label: i18nLocale("global.scanner"),
    value: "SCANNER",
  },
  {
    label: i18nLocale("global.online"),
    value: "WEB",
  },
  {
    label: i18nLocale("global.selfCashier"),
    value: "SELFCASHIER",
  }
];

export const taxRateArrary = [
  {
    label: i18nLocale("global.none"),
    value: "non"
  },
  {
    label: "0%",
    value: "zero",
  },
  {
    label: "8%",
    value: "percenteight"
  },
  {
    label: "10%",
    value: "percentTen"
  }
];

export const countryOptions = [
  { label: i18nLocale("global.Japan"), value: "Japan" },
  { label: i18nLocale("global.USA"), value: "US" },
  { label: i18nLocale("global.China"), value: "China" },
  { label: i18nLocale("global.UK"), value: "UK" }
];

export const categoryBtns = ["G", "PG12", "R15+", "R18+"];

export const unDisplayBtns = [
  {
    label: i18nLocale("global.POS"),
    value: "hiddenPos"
  },
  {
    label: i18nLocale("global.selfCashier"),
    value: "hiddenSelfCashier"
  },
  {
    label: i18nLocale("global.online"),
    value: "hiddenWeb"
  },
  {
    label: i18nLocale("global.CMS"),
    value: "hiddenCms"
  }
];

export const releaseDateTypeOptions = [
  {
    value: "DATE",
    label: i18nLocale("movie.release.type1"),
  },
  {
    value: "STR",
    label: i18nLocale("movie.release.type2"),
  },
  {
    value: "NONE",
    label: i18nLocale("movie.release.type3"),
  },
];

export const formRules = {
  name: [
    {
      required: true,
      message: i18nLocale("movie.plsEnterMovieName"),
      trigger: ["blur", "change"],
    }
  ],
  durationMin: [
    {
      required: true,
      message: i18nLocale("movie.plsEnterMovieLength"),
      trigger: "blur",
    },
    {
      validator: positiveNumValidator,
      trigger: "blur",
    },
  ],
  trailerTimeMin: [
    {
      required: true,
      message: i18nLocale("movie.plsEnterMovieTrailerLength"),
      trigger: "blur",
    },
    {
      validator: positiveNumValidator,
      trigger: "blur",
    },
  ],
  releaseTime: [
    {
      required: true,
      message: i18nLocale("movie.plsSelectReleaseDate"),
      trigger: "change",
    }
  ],
  taxRate: [
    {
      required: true,
      message: i18nLocale("movie.plsEnterMovieLength"),
      trigger: "blur",
    },
  ],
  sort: [
    {
      validator: positiveNumValidator,
      trigger: "blur",
    }
  ],
  openDateType: [
    {
      required: true,
      message: i18nLocale("movie.plsSelectReleseDateType"),
      trigger: "change",
    },
  ],
  openDateStr: [
    {
      required: true,
      message: i18nLocale("movie.plsEnterReleaseDate"),
      trigger: "blur",
    },
  ],
  category: [
    {
      required: true,
      message: i18nLocale("movie.plsSelectClassify"),
      trigger: "change",
    },
  ],
  openWeekStartDay: [
    {
      required: true,
      message: i18nLocale("movie.plsSelectOpenStartingDay"),
      trigger: "change",
    },
  ],
  // resetDays4Week:  [
  //   {
  //     required: true,
  //     message: i18nLocale("movie.plsEnterResetDays4Week"),
  //     trigger: "blur",
  //   },
  //   {
  //     validator: positiveNumValidator,
  //     trigger: "blur",
  //   }
  // ],
};

export const shareItemRules = [ {
  validator: percentageValidator,
  trigger: "blur",
} ];

export const mandatoryField = [ {
  required: true,
  message: i18nLocale("form.mandatoryField"),
  trigger: ["change", "blur"],
} ];

export const optionalField = [ {
  required: false,
} ];

export const currencyList = [
  {
    label: i18nLocale("global.circle"),
    value: "yen",
  },
  {
    label: "%",
    value: "percent",
  }
];

export const ticketCoordinationObj = {
  deviceType: "",
  checkMsg: "",
};

export const ticketUtilizeObj = {
  name: "",
  clientId: "",
  brandId: "",
  sort: 0,
  boxOfficeAmount: "",
  sellAmount: "",
  actualAmount: "",
  feeCircle: 0,
  feeCircleType: "yen",
  glassesAmount: 0,
  ticketingCode: "",
  checkMessages: [ tranfResData(ticketCoordinationObj) ],
  mobilize: false,
  usableVersion1: "",
  useNumber: 1,
  toBeDelete: false,
  type: "",
  filmId: "",
  category: "01"
};

export const shareObj = {
  normalShare: 0,
  morningShare: 0,
  eveningShare: 0,
  overNightShare: 0,
  specialShare: 0,
  stableMoney: 0,
  shareStartDate: moment(new Date()).format("YYYY-MM-DD"),
  shareEndDate: moment(new Date()).format("YYYY-MM-DD"),
};

export const initFormData = () => {
  return {
    name: "",
    slogan: "",
    synopsisTitle: "",
    synopsis: "",
    profileTitle: "",
    profile: "",
    durationMin: "",
    trailerTimeMin: "",
    releaseTime: null,
    genres: [],
    areas: [],
    directors: [],
    actors: [],
    intro: "",
    category: "",
    copyRight: "",
    distributor: "",
    trailers: [ "" ],
    website: "",
    imdbUrl: "",
    posters: "",
    stills: [],
    sort: "",
    hiddenCms: false,
    hiddenPos: false,
    hiddenSelfCashier: false,
    hiddenWeb: false,
    openWeekStartDay: "",
    openWeekStartDate: 0, // default value
    versionMasterMsg: "",
    filmSearchId: "",
    taxRate: "percentTen",
    // share: [ { ...shareObj } ],
    share: [],
    approveDate: moment().startOf("day").valueOf(),
    openDateType: "DATE",
    openDateStr: "",
    originalName: "",
    hpRelease: true,
    // resetDays4Week: null,
    writers: [],
    credit: "",
    productionYear: "",
    national: false,
    otherNational: false,
    nationalTicket: [],
    otherNationalTicket: [],
  };
};

export const sortTypeOptions = [
  {
    label: i18nLocale("global.sort.ascending"),
    value: "ASC",
  },
  {
    label: i18nLocale("global.sort.descending"),
    value: "DESC",
  },
];

export const moviTicketAuthority = {
  [adminTypeList.SUP_AMIN]: {
    type: adminTypeList.SUP_AMIN,
    edit: true,
    add: true,
    del: true,
    editFields: [
      "name",
      "boxOfficeAmount",
      "sellAmount",
      "glassesAmount",
      "ticketingCode",
      "useNumber",
    ],
    checkMessagesAuth: {
      add: false,
      del: false,
    },
  },
  [adminTypeList.BRAND]: {
    type: adminTypeList.BRAND,
    edit: true,
    add: false,
    del: false,
    editFields: [
      "clientId",
      "actualAmount",
      "feeCircle",
      "feeCircleType",
      "checkMessages",
      "mobilize",
    ],
    checkMessagesAuth: {
      add: true,
      del: true,
    },
  },
  [adminTypeList.CINEMA]: {
    type: adminTypeList.CINEMA,
    edit: true,
    add: false,
    del: false,
    editFields: [
      "clientId",
      "actualAmount",
      "feeCircle",
      "feeCircleType",
      "usableVersion1",
      "checkMessages",
      "mobilize",
    ],
    checkMessagesAuth: {
      add: true,
      del: true,
    },
  },
};

export const movieDetailAuthority = {
  [adminTypeList.SUP_AMIN]: {
    type: adminTypeList.SUP_AMIN,
    edit: false,
    add: false,
    del: false,
    editFields: [],
    checkMessagesAuth: {
      add: false,
      del: false,
    },
  },
  [adminTypeList.BRAND]: {
    type: adminTypeList.BRAND,
    edit: true,
    add: false,
    del: false,
    editFields: [
      "clientId",
    ],
    checkMessagesAuth: {
      add: false,
      del: false,
    },
  },
  [adminTypeList.CINEMA]: {
    type: adminTypeList.CINEMA,
    edit: true,
    add: false,
    del: false,
    editFields: [
      "clientId",
      // "usableVersion1",
    ],
    checkMessagesAuth: {
      add: false,
      del: false,
    },
  },
};

export const movieDetailAuthorityOther = {
  [adminTypeList.SUP_AMIN]: {
    type: adminTypeList.SUP_AMIN,
    edit: false,
    add: false,
    del: false,
    editFields: [],
    checkMessagesAuth: {
      add: false,
      del: false,
    },
    isOtherType: true,
  },
  [adminTypeList.BRAND]: {
    type: adminTypeList.BRAND,
    edit: false,
    add: false,
    del: false,
    editFields: [],
    checkMessagesAuth: {
      add: false,
      del: false,
    },
    isOtherType: true,
  },
  [adminTypeList.CINEMA]: {
    type: adminTypeList.CINEMA,
    edit: true,
    add: true,
    del: true,
    editFields: [
      "name",
      "clientId",
      "sort",
      "boxOfficeAmount",
      "actualAmount",
      "feeCircle",
      "feeCircleType",
      "ticketingCode",
      "useNumber",
      "usableVersion1",
      "checkMessages",
      "mobilize",
    ],
    checkMessagesAuth: {
      add: true,
      del: true,
    },
    isOtherType: true,
  },
};

export const listApiTypeMapping = {
  [adminTypeList.CINEMA]: "cinema",
  [adminTypeList.BRAND]: "brand",
  [adminTypeList.SUP_AMIN]: "global",
};

export const noneOption = {
  id: "none",
  name: i18nLocale("global.none"),
};

export const checkValidData = _obj => {
  return !Object.values(_obj).some(value => [undefined, null, ""].includes(value));
};
